import { observer, use$ } from '@legendapp/state/react';
import { Box, Center, Modal, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useSession } from '../hooks/useSession.hook';
import { sessionState$ } from '../state';

export const SessionCheckModal = observer(() => {
  const { t } = useTranslation();

  useSession();

  // Get session expired state from global state
  const isSessionExpired = use$(sessionState$.isSessionExpired);

  return (
    <Modal
      centered
      closeOnClickOutside={!isSessionExpired}
      closeOnEscape={!isSessionExpired}
      data-test-id="session-check-modal"
      // biome-ignore lint/suspicious/noEmptyBlockStatements: empty function to prevent closing
      onClose={() => {}}
      opened={isSessionExpired}
      overlayProps={{
        backgroundOpacity: 0.9,
      }}
      radius="md"
      size="md"
      withCloseButton={!isSessionExpired}
      zIndex={9999}
    >
      <Box data-test-id="session-check-content" p="xl">
        <Center>
          <Box
            data-test-id={`session-check-emoji-${
              isSessionExpired ? 'expired' : 'checking'
            }`}
            mb="md"
            style={{ fontSize: 50 }}
          >
            {isSessionExpired ? '⚠️' : '⏳'}
          </Box>
        </Center>
        {isSessionExpired ? (
          <>
            <Text
              data-test-id="session-expired-title"
              fw={600}
              mb="md"
              size="xl"
              ta="center"
            >
              {t('session.titleExpired')}
            </Text>
            <Text data-test-id="session-expired-message" mb="xl" ta="center">
              {t('session.messageExpired')}
            </Text>
          </>
        ) : (
          <>
            <Text
              data-test-id="session-check-title"
              fw={600}
              mb="md"
              size="xl"
              ta="center"
            >
              {t('session.title')}
            </Text>
            <Text data-test-id="session-check-message" mb="xl" ta="center">
              {t('session.message')}
            </Text>
          </>
        )}
      </Box>
    </Modal>
  );
});
